import React from 'react';

const Hero: React.FC = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center pt-24 overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-1/4 -left-20 w-96 h-96 bg-blue-500/10 rounded-full blur-[120px] pointer-events-none"></div>
      <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-neutral-500/10 rounded-full blur-[120px] pointer-events-none"></div>
      
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-6xl">
          <div className="inline-block px-4 py-1.5 mb-8 border border-white/10 rounded-full bg-white/5 backdrop-blur-sm">
            <span className="text-xs font-bold tracking-[0.3em] uppercase opacity-70">Bespoke Management & Consulting</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl lg:text-[110px] leading-[0.95] font-syne font-extrabold mb-12 tracking-tighter">
            WE HELP <br />
            <span className="text-gradient uppercase">SCALE BRANDS.</span>
          </h1>
          
          <p className="text-lg md:text-2xl text-neutral-400 max-w-4xl font-light leading-relaxed mb-12">
            Layer One Management provides the resources to help companies scale. Expertly navigating technology, distribution, legal, accounting, and marketing for consumer products, entertainment and tech industries.
          </p>

          <div className="flex flex-col sm:flex-row gap-6">
            <button 
              onClick={() => scrollToSection('services')}
              className="px-10 py-5 bg-white text-black font-bold text-sm tracking-widest uppercase hover:bg-neutral-200 transition-all"
            >
              Explore Our Expertise
            </button>
            <button 
              onClick={() => scrollToSection('lab')}
              className="px-10 py-5 border border-white/20 text-white font-bold text-sm tracking-widest uppercase hover:bg-white/5 transition-all"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;